var userAgent = typeof window !== 'undefined' && window.navigator.userAgent;
export const isEdge = /(MSIE |Trident\/|Edge\/)/i.test(userAgent);
